import LANG from '@/common/lang'
import regExp from '@/common/regExp'

const UTIL = {
  copyToClipboard: function (string) {
    var textarea = document.createElement('textarea')
    textarea.value = string
    document.body.appendChild(textarea)
    textarea.select()
    textarea.setSelectionRange(0, 9999)
    document.execCommand('copy')
    document.body.removeChild(textarea)
  },
  decodeHtml: function (entity) {
    const textarea = document.createElement('textarea')
    textarea.innerHTML = entity
    return textarea.value
  },
  fillLangs: function (langObj, defaultStr) {
    const langValues = LANG.valueObj()
    const hasDefaultStr = regExp.replaceAllEmpty(defaultStr) !== ''
    langObj = Object.assign(langValues, langObj)
    if (hasDefaultStr) {
      Object.keys(langObj).forEach(function (lang) {
        langObj[lang] = regExp.replaceAllEmpty(langObj[lang]) === '' ? defaultStr : langObj[lang]
      })
    }
    return langObj
  },
  translate: function (str) {
    console.log(str)
  }
}

export default UTIL
